export default __webpack_public_path__ + "static/media/AD.5c4da062.svg";